<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> {{ firstVisitor ? '初回' : '' }}予約 </FufuHeader>
    <v-container class="white" fill-height>
      <v-layout column>
        <v-layout justify-center class="body-1 fufugrey2--text">
          <span v-if="menu"> {{ menu.displayName || menu.name }} </span>
          <span v-if="menu && menu.color">
            &nbsp; / {{ menu.color.displayName }}
          </span>
          <span v-if="menuOption">
            &nbsp; / {{ menuOption.displayName || menuOption.name }}
          </span>
          <span v-if="scalpCare">
            &nbsp; / {{ scalpCare.displayName || scalpCare.name }}
          </span>
        </v-layout>
        <v-layout>
          <v-flex xs4>
            <v-btn
              :to="{ name: 'TimeSelection', query: $route.query }"
              text
              exact
              color="primary"
              replace
            >
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-center">
            お客さま情報を入力してください。
          </v-flex>
        </v-layout>

        <v-card flat>
          <v-toolbar flat color="bgColor">
            <v-layout justify-center>
              <span class="primary--text subtitle-1">
                <b>お客さま情報を入力ください</b>
              </span>
            </v-layout>
          </v-toolbar>
          <v-card-text>
            <v-alert
              v-for="e in errors.nonFieldErrors"
              :key="e"
              type="error"
              outlined
            >
              {{ e }}
            </v-alert>
            <template v-if="!(firstVisitor && mode === 2)">
              <v-layout row>
                <v-flex xs6 class="pr-3">
                  <v-text-field
                    v-model="account"
                    :error-messages="errors.membershipNumber"
                    :disabled="newCustomer"
                    label="お客様ID"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="membershipFamilyNameKana"
                    :error-messages="errors.membershipFamilyNameKana"
                    :disabled="newCustomer"
                    label="せい（全角ひらがな）"
                  />
                </v-flex>
              </v-layout>

              <b>お客様ID</b
              >を入力すると、アプリ／予約サイトで<b>ご予約の確認・変更</b>ができます<br />
              ※アプリ／予約サイトでの<b>お客様ID</b>のご登録が必要です
              <br />
              <span v-if="mode === 2">
                携帯電話番号をご登録されている場合、ご予約日時をショートメール(SMS)でお知らせいたします。
              </span>
              <v-layout justify-center>
                <v-checkbox v-model="newCustomer" color="primary">
                  <span slot="label" class="primary--text">
                    <b>お客様IDがわからない方</b>
                  </span>
                </v-checkbox>
              </v-layout>
            </template>

            <v-layout row>
              <v-text-field
                v-model="familyNameKana"
                :error-messages="errors.familyNameKana"
                :disabled="!newCustomer"
                label="せい（全角ひらがな）"
              />
              <v-text-field
                v-model="givenNameKana"
                :error-messages="errors.givenNameKana"
                :disabled="!newCustomer"
                label="めい（全角ひらがな）"
                class="ml-3"
              />
              <v-text-field
                v-model="phoneNumber"
                :error-messages="errors.phoneNumber"
                :disabled="!newCustomer"
                label="電話番号"
                class="ml-3"
              />
            </v-layout>

            <span v-if="mode === 2">
              携帯電話番号をご登録されている場合、ご予約日時をショートメール(SMS)でお知らせいたします。
            </span>
          </v-card-text>
        </v-card>
        <v-layout>
          <v-flex xs4 offset-xs4>
            <v-btn
              color="fufuyellow"
              text-color="fufugrey2"
              large
              block
              @click="submit"
            >
              <span slass="subtitle-1">
                <b> 予約内容の確認へ </b>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FufuHeader from '@/components/FufuHeader'

export default {
  name: 'CustomerInputView',
  components: {
    FufuHeader,
  },
  inject: ['$error'],
  props: {
    shopId: {
      type: String,
      default: '',
    },
    menuId: {
      type: [Number, String],
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },

    firstVisitor: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    // shops: [],
    shop: null,
    menu: null,
    menuOption: null,
    scalpCare: null,

    membershipShop: null,
    account: '',
    membershipFamilyNameKana: '',
    familyNameKana: '',
    givenNameKana: '',
    phoneNumber: '',
    newCustomer: false,
    errors: {},

    reservation: null,
  }),
  computed: {
    done() {
      return Boolean(this.reservation)
    },
  },
  created() {
    this.fetchData()
    if (this.firstVisitor && this.mode === 2) this.newCustomer = true
  },
  methods: {
    async fetchData() {
      try {
        // const fetchShops = async url => {
        //   let { results, next } = await (url
        //     ? this.$api.http(url)
        //     : this.$api.shops().list())
        //   this.shops = this.shops.concat(results)
        //   if (next) fetchShops(next)
        // }
        // fetchShops()
        let optId = this.$route.query.menuOption
        const scalpCareId = this.$route.query.scalpCare
        let shopAPI = this.$api.shops(this.shopId)
        let [shop, menu, menuOption, scalpCare] = await Promise.all([
          shopAPI.get(),
          shopAPI.menus(this.menuId).get(),
          optId && shopAPI.menuOptions(optId).get(),
          scalpCareId && shopAPI.scalpCares(scalpCareId).get(),
        ])
        this.shop = shop
        this.menu = menu
        this.menuOption = menuOption || null
        this.scalpCare = scalpCare || null
      } catch (err) {
        this.$error(err)
      }
    },
    cleanName() {
      this.givenNameKana = this.hiraToKana(this.givenNameKana)
      this.familyNameKana = this.hiraToKana(this.familyNameKana)
      this.membershipFamilyNameKana = this.hiraToKana(
        this.membershipFamilyNameKana
      )
    },
    hiraToKana(str) {
      return str.replace(/[\u3041-\u3096]/g, match => {
        var chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    async submit() {
      this.cleanName()
      let newCustomer = this.newCustomer
      let data = {
        shop: this.shopId,
        menu: this.menuId,
        treatment: this.$route.query.menuOption || null,
        scalpCare: this.$route.query.scalpCare || null,
        date: this.date,
        time: this.time,

        newCustomer,
        // membershipShop: newCustomer ? null : this.membershipShop,
        membershipNumber: newCustomer ? null : this.account,
        membershipFamilyNameKana: newCustomer
          ? null
          : this.membershipFamilyNameKana,
        familyNameKana: this.familyNameKana,
        givenNameKana: this.givenNameKana,
        phoneNumber: this.phoneNumber,
      }
      try {
        this.errors = {}
        await this.$api.reservations().validateInShop(data)
        this.$router.replace({
          name: 'Confirm',
          query: Object.assign(
            {
              first: this.firstVisitor,
            },
            data
          ),
        })
      } catch (err) {
        if (err.status === 400) {
          this.errors = err.response.data
        } else {
          this.$toast.error('サーバとの通信に失敗しました。')
          throw err
        }
      }
    },
  },
}
</script>

<style></style>
